export default __webpack_public_path__ + "static/media/big-deal-50T-background.9d7c9653.jpg";